import type { ITaskRepository } from "@src/domain/pascos/repository/task_repository";
import type { TaskListItemDTO } from "../dto";
import { TaskDtoMapper } from "../mappers/task-dto.mapper";

/**
 * Use Case: List All Tasks
 * Retrieves all task records from the system
 */
export class ListAllTasksUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    /**
     * Execute the use case
     * @returns Promise<TaskListItemDTO[]> - Array of Task DTOs for list display
     */
    async execute(): Promise<TaskListItemDTO[]> {
        const tasks = await this.taskRepository.listAll();
        return TaskDtoMapper.toListItemDTOArray(tasks);
    }
}
